"use strict";

require("./style.scss");